import { Grid, Box, Typography } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { useState } from "react";
import { OneOnOneStyle } from "./OneOnOneStyle";
import { IconDatePicker, IconLot } from "icons";

const OneOnOneOverview = ({ meetingToEdit, setMeetingToEdit }) => {

    const classes = OneOnOneStyle();

    const [openDialog, setOpenDialog] = useState(true);

    const handleClose = () => {
        setOpenDialog(false);
        setMeetingToEdit(null)
    }


    // For details fields: label above, value in outlined box
    const displayDetailField = (label, value) => (
        <Box mb={3}>
            <Typography variant="subtitle1" style={{ fontWeight: 500, marginBottom: 4 }}>{label}:</Typography>
            <Box
                border={1}
                borderColor="grey.400"
                borderRadius={6}
                p={3}
                minHeight={80}
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgcolor="#fafbfc"
            >
                <Typography variant="body1" style={{ width: '100%' }}>
                    {value || <em>—</em>}
                </Typography>
            </Box>
        </Box>
    );


    return (
        <>
            {
                <Dialog open={openDialog} onClose={() => handleClose()} aria-labelledby="form-dialog-title" maxWidth='md' fullWidth>
                    <DialogContent>
                        <div className={classes.viewForm}>
                            <Grid container alignItems="center" justifyContent="space-between" style={{ marginBottom: 24 }}>
                                <Grid item xs={4}>
                                    <Box display="flex" alignItems="center">
                                        <IconDatePicker />
                                        <Typography variant="subtitle1" style={{ fontWeight: 500, marginLeft: 10 }}>
                                            {meetingToEdit?.formatedMeetingDate}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={4}></Grid>
                                <Grid item xs={4} style={{ textAlign: 'right' }}>
                                    <Box display="flex" alignItems="center" justifyContent="flex-end">
                                        <IconLot />
                                        <Typography variant="subtitle1" style={{ fontWeight: 500, marginLeft: 10 }}>
                                            {meetingToEdit?.lot}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Box display="flex" flexDirection="column" alignItems="center" mb={1}>
                                <Typography variant="h6" style={{ fontWeight: 500 }}>
                                    {meetingToEdit?.employeeName}
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {meetingToEdit?.meetingPlaceName}
                                </Typography>
                            </Box>

                            {/* Details fields */}
                            <Box mt={4}>
                                {displayDetailField('Goals', meetingToEdit?.goals)}
                                {displayDetailField('Successes', meetingToEdit?.successes)}
                                {displayDetailField('Opportunities', meetingToEdit?.opportunities)}
                                {displayDetailField('Timeline and next steps', meetingToEdit?.nextSteps)}
                                {displayDetailField('Is there anything the employee would like to change on the lot or at work?', meetingToEdit?.changes)}
                                {displayDetailField('Notes', meetingToEdit?.notes)}
                            </Box>

                            {/* Yes/No fields at the bottom */}
                            <Box mt={2}>
                                <Typography variant="subtitle1">
                                    Does the employee know who to contact in an emergency? <strong>{meetingToEdit?.contactEmergency ? 'Yes' : 'No'}</strong>
                                </Typography>
                                <Typography variant="subtitle1">
                                    Does the employee know how to contact HR? <strong>{meetingToEdit?.contactHr ? 'Yes' : 'No'}</strong>
                                </Typography>
                            </Box>
                        </div>
                    </DialogContent>
                </Dialog>
            }
        </>
    );
};

export default OneOnOneOverview;
